var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-footer"},[_vm._v(" © "+_vm._s(_vm.copyrightYear)+" The United Brotherhood of Carpenters and Joiners of America. All rights reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }